/* eslint-disable */

const getProfileRows = () => {
    const reactTable = window.siiselTables && window.siiselTables.profilesIndex;
    if (reactTable) {
        return reactTable.getRows();
    }

    const profileTable = $('#profilesIndex')

    if (!profileTable || profileTable.length === 0) {
        return null
    }

    return profileTable
        .DataTable()
        .rows()
        .data()
        .toArray();
}

const getProfileIds = () => {
    const rows = getProfileRows();
    return rows ? rows.map(r => r.id) : null;
}

$('#export').on('click', () => {
    const ids = getProfileIds();
    if (!ids) {
        return
    }

    $("#profileIds").val(ids.join(','));

    const urlExport = linksoft.url.exportProfiles({ ids: ids.join(','), connectionId: $.connection.hub.id })

    $.ajax({
        url: urlExport,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: response => {
            console.log(response)
        },
        error: error => {
            console.log(error)
        }
    })
})


$('#export-with-filter').on('click', () => {
    const ids = getProfileIds();
    if (!ids) {
        return
    }

    $("#profileIds").val(ids.join(','));

    const url = linksoft.url.axesTypes({ ids: ids.join(',') });
    window.location.href = url;
})

